module.exports = __webpack_public_path__ + "img/jaklingko.0b275759.svg";